var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-card',{staticClass:"card-block no-margin",attrs:{"title":_vm.$t('trips.registerTrip.titleInformation')}},[_c('f7-block',[_c('DxForm',{attrs:{"on-field-data-changed":_vm.onFieldDataChanged,"show-colon-after-label":false,"label-location":"top","form-data":_vm.tripInfo,"items":_vm.infoTripFields}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }